export var extractDataAttribute = function extractDataAttribute(event, name) {
  return event.currentTarget.getAttribute("data-".concat(name));
};